module.exports = __webpack_public_path__ + "img/Button.b2b5b6eb.svg";